import { Component, OnInit,Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-eap-type-reorder',
  templateUrl: './eap-type-reorder.component.html',
  styleUrls: ['./eap-type-reorder.component.scss']
})
export class EapTypeReorderComponent implements OnInit {
  @Input() public Content: any;
  content:any;
  documentList: any = [];
  action: Subject<any> = new Subject();
  ChangesHappend:boolean=false;

  constructor(
    public modalRef: NgbActiveModal,
    private commonService:CommonService
  ) { }

  ngOnInit(): void {
    this.documentList = this.Content.content.Data;
  }

  SaveOrder()
  {
    //if(this.ChangesHappend)
   // {
     // this.action.next(this.documentList);
      this.modalRef.close(this.documentList);
    //}
   // else{
      // this.commonService.ValidationBanner("No changes have been performed");
   // }
  }
  Close()
  {
    this.canExit().then(x=>{
      this.modalRef.dismiss();
    });  
  }

  listSorted(event:any){
   this.ChangesHappend=true;
  }

  canExit() {
    if (this.ChangesHappend) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

}
